import { ConnectedPosition } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { BackpackIconsModule } from 'app/backpack-icons/backpack-icons.module';

// TODO: extract to composed directives when available in CDK 15
export const CDK_MENU_POSITIONS: ConnectedPosition[] = [
	{ originY: 'bottom', originX: 'end', overlayX: 'end', overlayY: 'top', offsetY: 4 },
	{ originY: 'top', originX: 'end', overlayX: 'end', overlayY: 'bottom', offsetY: -4 },
];

@Component({
	standalone: true,
	selector: 'bp-action-menu',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [BackpackIconsModule, CommonModule],
	host: {
		class: 'tw-bg-white tw-box-border tw-p-2 tw-rounded-lg tw-shadow-base tw-flex tw-flex-col tw-gap-1 tw-font-normal',
	},
	template: ` <ng-content></ng-content> `,
})
export class ActionMenuComponent {
	// Use to override default innate content-based menu width.
	//
	// For instance, to simulate a full-width dropdown input, you can match the width of the menu trigger:
	//   <bp-action-menu cdkMenu [customWidth]="menuTrigger.offsetWidth">
	@HostBinding('style.width.px')
	@Input()
	customWidth?: number;

	// TODO: use composed directives when available in CDK 15
}

@Component({
	standalone: true,
	selector: 'bp-action-menu-item',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [BackpackIconsModule, CommonModule],
	host: {
		class: 'tw-flex tw-items-center tw-gap-1 tw-px-3 tw-rounded-lg tw-text-sm tw-leading-none tw-h-9 tw-outline-none hover:tw-bg-gray-050',
		'[class.tw-cursor-pointer]': '!disabled',
		'[class.tw-opacity-50]': 'disabled',
	},
	template: ` <ng-content></ng-content>`,
})
export class ActionMenuItemComponent {
	@Input() disabled = false;
	// TODO: use composed directives when available in CDK 15
}
